import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  viewPhotoLoaded: false,
  viewPhotoById: {},
};

const viewPhotoSlice = createSlice({
  name: "viewPhoto",
  initialState,
  reducers: {
    loadViewPhotos: (state, action) => {
      state.viewPhotoLoaded = true;
      state.photos = action.payload.photos;
      const viewPhotoById = {};
      action.payload.photos.map((photo) => {
        viewPhotoById[photo["photo_id"]] = photo;
        return null;
      });
      state.viewPhotoById = viewPhotoById;
    },
    resetViewPhotos: (state) => {
      state.viewPhotoById = {};
      state.viewPhotoLoaded = false;
    },
  },
});

export const { loadViewPhotos, photoUploaded, resetViewPhotos, setViewIndex } =
  viewPhotoSlice.actions;
export default viewPhotoSlice.reducer;
